module.exports = __webpack_public_path__ + "img/6.f27c970a.png";